$(document).ready(function(e) {
	
	$('ul.mainMenu li a').click(function(event) {
		event.preventDefault();
		var ids = $(this).attr('href');
		 $('html, body').animate({
			scrollTop: $(ids).offset().top - 50
		}, 2000);
	});
	
	// $(".btn_scorall").click(function() {
	// 	$('html, body').animate({
	// 		scrollTop: $("#getOrder").offset().top - 50
	// 	}, 2000);
	// });
	
		
	$('.package_slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		asNavFor: '.package_slider_nav',
		autoplay: false,
		autoplaySpeed: 11000,
		dots: false,
	});

	$('.package_slider_nav').slick({
		slidesToShow:6,
		slidesToScroll: 1,
		asNavFor: '.package_slider',
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		infinite: true,
		arrows: false,
		rtl: false,
	});	
		
	// <!-------------PKG_OPT-------------------->
	// $('.prd-opt').click(function(e) {
    //    $('.prd-opt').removeClass('active');
	//    $(this).addClass('active');
    // });
	
	// $('.prd-opt').click(function(e) {
	// 	if (!$(this).find(".pck-bx-rad").attr("checked")) {
	// 		$(this).parent('.selectBox').find(".pck-bx-rad").removeAttr("checked");
	// 		$(this).find(".pck-bx-rad").attr("checked", "checked");
	// 	}
		
	// 	$('.cut-price').html($(this).attr("data-retail"));
	// 	$('.total-price').html($(this).attr("data-total"));
	// });
	
	//accordion Ingredients JS 
	$(".ingredients-heading").click(function() {
		
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.ingredients-content');
		var idx = $('.ingredients-content').index(answerDiv);
		
		$('.ingredients-content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.ingredients-heading').removeClass('ingredients-heading-open');
				});
			}
        });
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('ingredients-heading-open');
			});
		} else {
		  questionDiv.addClass('ingredients-heading-open');
		  answerDiv.stop().slideDown(500);
		}
	});
	
	
	$('.option_row').click(function(e) {
		$('.option_row').removeClass('active');
		$(this).addClass('active');
        $(this).parent('.package_row').find(".pck-bx-rad").removeAttr("checked");
	});
	
	$('.extra-opt').click(function(e) {
        $('.package_col').removeClass('active');
		$('.regular-pkg').hide();
		$('.extra-pkg').fadeIn();
        $('.package_col.pckex3').addClass('active');
        $('.pckex3 .radio_opt .pck-bx-rad').prop('checked', true).trigger('change');
        updateCartButtonUrl();        
	});
	
	$('.regular-opt').click(function(e) {
        $('.package_col').removeClass('active');
		$('.regular-pkg').fadeIn();
		$('.extra-pkg').hide();
        $('.package_col.pckreg3').addClass('active');
        $('.pckreg3 .radio_opt .pck-bx-rad').prop('checked', true).trigger('change');
        updateCartButtonUrl();
	});
	

	$('.package_col').click(function(e) {
		if (!$(this).find(".pck-bx-rad").attr("checked")) {
			$(this).parent('.package_row').find(".pck-bx-rad").removeAttr("checked");
			$(this).find(".pck-bx-rad").attr("checked", "checked");
		}
	});
	
	$('.package_col').click(function(e) {
		$(this).closest('.package_row').find('.package_col').removeClass('active');
		$(this).addClass('active');	
	});
			
			
	//accordion JS 
	$(".acdn-heading").click(function() {
			
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
		
	});
	
    // Update displayed prices and URLs on page load
    // updateDisplayedPrices();
    updateCartButtonUrl();

    // Handle clicking on a package option
    $('.package_col').click(function() {
        $('.package_col').removeClass('active');
        $(this).addClass('active');

        // Ensure the corresponding radio button is checked
        $(".pck-bx-rad").prop("checked", false);
        $(this).find(".pck-bx-rad").prop("checked", true).trigger('change');

        // Update displayed prices and URLs when a new package is selected
        // updateDisplayedPrices();
        updateCartButtonUrl();
    });

    // // Function to update the displayed prices
    // function updateDisplayedPrices() {
    //     const activePackage = $('.package_col.active');
    //     if (activePackage.length) {
    //         $('.cut-price').text(activePackage.attr("data-retail"));
    //         $('.total-price').text(activePackage.attr("data-total"));
    //     }
    // }

    // Function to set the URL for the "Add to Cart" button
    function updateCartButtonUrl() {
        const selectedPackage = $('.package_col.active').find('.pck-bx-rad').data('package');
        if (selectedPackage) {
            const baseCartUrl = "https://db0aca-7e.myshopify.com/cart/";

            const params = new URLSearchParams(window.location.search);
            params.set('channel', 'buy_button');

            const discountCode = $('.package_col.active').data('discount-code') || '';
            params.set('discount', discountCode);

            const finalUrl = `${baseCartUrl}${selectedPackage}?${params.toString()}`;

            $('.cart_common_btn').off('click').on('click', function(event) {
                event.preventDefault();
                window.location.href = finalUrl;
                // console.log("Sent", finalUrl)
            });
        }
    }
});
	
$(document).scroll(function() {		
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
});



function getTimeRemaining(endtime) {
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
    };
}

function initializeClock(id, endtime) {
    var clock = document.getElementById(id);
    // var daysSpan = clock.querySelector('.days');
    var hoursSpan = clock.querySelector('.hours');
    var minutesSpan = clock.querySelector('.minutes');
    var secondsSpan = clock.querySelector('.seconds');

    function updateClock() {
    var t = getTimeRemaining(endtime);

    // daysSpan.innerHTML = t.days;
    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

    if (t.total <= 0) {
        clearInterval(timeinterval);
    }
    }

    updateClock();
    var timeinterval = setInterval(updateClock, 1000);
}
	
var deadline = new Date(Date.parse(new Date()) + 360 * 100 * 1000);

initializeClock('clockdiv', deadline);


document.addEventListener('DOMContentLoaded', function() {
    const stickyCTA = document.getElementById('stickyCTA');

    // Function to check if any part of elements with a given class is in the viewport
    function isAnyPartOfElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

        // Check if any part of the element is visible on screen
        const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
        const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

        return (vertInView && horInView);
    }

    // Handle scroll events to toggle visibility of the sticky CTA
    window.addEventListener('scroll', function() {
        let sectionVisible = Array.from(document.querySelectorAll('.section10')).some(isAnyPartOfElementInViewport);

        if (sectionVisible) {
            stickyCTA.style.opacity = '0';
            stickyCTA.style.visibility = 'hidden';
        } else {
            stickyCTA.style.opacity = '1';
            stickyCTA.style.visibility = 'visible';
        }
    });

    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent default anchor click behavior

            var target = document.querySelector(this.getAttribute('href'));
            if (target) {
                var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 100;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth' // Smooth scroll
                });
            }
        });
    });
});


document.addEventListener('DOMContentLoaded', function() {
    let trackingFired = false;

    function trackPageView() {
        if (!trackingFired) {
			axon("track", "view_item", {
            	"currency": "USD",
            	"items": [
					{
						"price": "35",
						"item_name": "PMS Support THC Gummies",
						"item_id": "8741078761710",
                        "item_variant_id": "46093876723950",
						"quantity": "1",
						"item_category_id": "469",
						"image_url": "https://cdn.shopify.com/s/files/1/0693/8119/3966/files/PMSSupportTHCGummies_PLP_StephRender_04012025.png",
					}
				]
        		});
            console.log('Page view tracked PMS 5');
            trackingFired = true;
        }
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                trackPageView();
            }
        });
    }, {
        threshold: 0.05
    });

    const getOrderElement = document.getElementById('getOrder');
    if (getOrderElement) {
        observer.observe(getOrderElement);
    }

    $(".btn_scorall").click(function() {
        $('html, body').animate({
            scrollTop: $("#getOrder").offset().top - 60
        }, 2000, function() {

            trackPageView();
        });
    });

    
    if (getOrderElement && getOrderElement.getBoundingClientRect().top < window.innerHeight) {
        trackPageView();
    }
});

function createOrSyncCookies() {
	const primaryCookieName = 'axwrt';   // This is the main cookie we'll sync others to.
	const secondaryCookieName = '_axwrt'; // Axon Cookie
	let userId = getCookieValue(primaryCookieName) || getCookieValue(secondaryCookieName) || generateUserId(); // Use existing or generate new.

	// Sync both cookies - set the same userId
	setCookie(primaryCookieName, userId, 365, '/');
	setCookie(secondaryCookieName, userId, 365, '/');

	console.log('Cookies synchronized with UserId:', userId);
}

function generateUserId() {
	return 'uid_' + Math.random().toString(36).substr(2, 9);
}

function getCookieValue(cookieName) {
	var name = cookieName + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i].trim();
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return null;
}

function setCookie(name, value, days, path) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + value + expires + "; path=" + path;
}

createOrSyncCookies();